<div fxLayout="column" fxLayoutGap="10px">
  <div>
    <mat-card appearance="outlined" fxFlexFill fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"
              class="mat-elevation-z3 mat-amber-A100">
      <div fxFlex="grow" fxFlexAlign="center">
        {{ alertText }}
      </div>
    </mat-card>
  </div>
</div>
